<lsq-circle-loader *ngIf="!personDetail"></lsq-circle-loader>
<div *ngIf="personDetail" class="settings-profile">
    <div class="user-header section-header">
        <h2 class="user-name-heading section-heading h3">
            {{ userNameForHeading }}
            <span
                *ngIf="shouldDisplayOwnerBadge()"
                class="user-role-badge"
                i18n="Badge to show who is the owner"
            >
                Owner
            </span>
            <lsq-button
                *ngIf="!isEditingUserInfo"
                class="profile-edit-btn"
                appearance="transparent"
                (buttonClick)="editUserInfo()"
                i18n="Button to edit your profile"
            >
                Edit
            </lsq-button>
        </h2>
        <div class="user-meta-subheading section-subheading">{{ userTitle }}&nbsp;</div>
    </div>
    <div class="user-info">
        <div *ngIf="!isEditingUserInfo" class="user-info-display">
            <ng-template #userInfoDisplayPair let-label="label" let-key="key" let-isPhone="isPhone">
                <div class="user-info-display-pair">
                    <div
                        class="user-info-display-pair-label"
                        id="user-info-display-{{ kebabCase(key) }}-label"
                    >
                        <b>{{ label }}</b>
                    </div>
                    <div
                        class="user-info-display-pair-value"
                        [ngClass]="{ 'is-null': !personDetail[key] }"
                        id="user-info-display-{{ kebabCase(key) }}-value"
                        [attr.aria-describedby]="'user-info-display-' + kebabCase(key) + '-label'"
                    >
                        <ng-container *ngIf="personDetail[key] && !isPhone">{{
                            personDetail[key]
                        }}</ng-container>
                        <ng-container *ngIf="personDetail[key] && isPhone">{{
                            personDetail[key] | phone
                        }}</ng-container>
                        <ng-container
                            *ngIf="!personDetail[key]"
                            i18n="Replacement text for when no data is present"
                            >(none)</ng-container
                        >
                    </div>
                </div>
            </ng-template>

            <div class="user-info-display-group">
                <!-- firstName -->
                <ng-container
                    *ngTemplateOutlet="
                        userInfoDisplayPair;
                        context: {
                            label: firstNameLabel,
                            key: 'firstName'
                        }
                    "
                >
                </ng-container>

                <!-- lastName -->
                <ng-container
                    *ngTemplateOutlet="
                        userInfoDisplayPair;
                        context: {
                            label: lastNameLabel,
                            key: 'lastName'
                        }
                    "
                >
                </ng-container>

                <!-- title -->
                <ng-container
                    *ngTemplateOutlet="
                        userInfoDisplayPair;
                        context: {
                            label: titleLabel,
                            key: 'title'
                        }
                    "
                >
                </ng-container>
            </div>

            <div class="user-info-display-group">
                <!-- phoneNumber -->
                <ng-container
                    *ngTemplateOutlet="
                        userInfoDisplayPair;
                        context: {
                            label: phoneLabel,
                            key: 'phoneNumber',
                            isPhone: true
                        }
                    "
                >
                </ng-container>

                <!-- extension -->
                <ng-container
                    *ngTemplateOutlet="
                        userInfoDisplayPair;
                        context: {
                            label: extensionLabel,
                            key: 'phoneNumberExtension'
                        }
                    "
                >
                </ng-container>
            </div>
        </div>

        <form
            *ngIf="isEditingUserInfo"
            class="user-info-form"
            [formGroup]="userInfoFormGroup"
            (ngSubmit)="submitEditUserInfo()"
        >
            <div class="row">
                <div class="col-12 col-md-6">
                    <lsq-input
                        [group]="userInfoFormGroup"
                        [innerLabel]="true"
                        name="first-name"
                        formControlName="firstName"
                        [label]="firstNameLabel"
                    >
                    </lsq-input>
                </div>
                <div class="col-12 col-md-6">
                    <lsq-input
                        [group]="userInfoFormGroup"
                        [innerLabel]="true"
                        name="last-name"
                        formControlName="lastName"
                        [label]="lastNameLabel"
                    >
                    </lsq-input>
                </div>
                <div class="col-12">
                    <lsq-input
                        [group]="userInfoFormGroup"
                        [innerLabel]="true"
                        name="title"
                        formControlName="title"
                        [label]="titleLabel"
                    >
                    </lsq-input>
                </div>
                <div class="col-12 col-md-8">
                    <lsq-phone-input
                        name="phone"
                        [hasInnerLabel]="true"
                        [group]="userInfoFormGroup"
                        formControlName="phoneNumber"
                        [label]="phoneLabel"
                    >
                    </lsq-phone-input>
                </div>
                <div class="col-12 col-md-4">
                    <lsq-input
                        name="phone-extension"
                        [group]="userInfoFormGroup"
                        [innerLabel]="true"
                        type="tel"
                        formControlName="phoneNumberExtension"
                        [label]="extensionLabel"
                    >
                    </lsq-input>
                </div>
            </div>

            <div class="user-info-form-actions">
                <lsq-button
                    appearance="secondary"
                    (buttonClick)="cancelEditUserInfo()"
                    i18n="Cancel button"
                >
                    Cancel
                </lsq-button>
                <lsq-button
                    size="sm"
                    type="submit"
                    [group]="userInfoFormGroup"
                    [submitting]="isSubmittingUserInfoUpdate"
                    i18n="Save button"
                >
                    Save Changes
                </lsq-button>
            </div>
        </form>
    </div>

    <permissions [readOnly]="true" [modal]="false"></permissions>

    <ng-container *ngIf="userHasMfaEnabled$ | async">
        <two-factor></two-factor>
    </ng-container>

    <ng-container>
        <documents [personDetail]="personDetail"></documents>
    </ng-container>
</div>
